import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TableKey } from '@tradecafe/types/core';

export interface TriggerLogOverlayOptions {
  title: string;
  trigger_id: string;
}

@Component({
  selector: 'tc-trigger-log-overlay',
  templateUrl: './trigger-log-overlay.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TriggerLogOverlayComponent {
  private dialogData = inject<TriggerLogOverlayOptions>(MAT_DIALOG_DATA)
  private dialogRef = inject<MatDialogRef<TriggerLogOverlayComponent, void>>(MatDialogRef)


  tableIdentity = TableKey.TriggersAudit;
  title = this.dialogData.title;
  auditLogFilter = {
    component: ["notification_trigger"],
    resource_id: [this.dialogData.trigger_id],
  };
  cancel() {
    this.dialogRef.close();
  }
}
